export default __webpack_public_path__ + "static/media/flag-brunei.6cef89e6.svg";